import * as validators from '@vuelidate/validators';
import { helpers } from '@vuelidate/validators';
import { type ErrorObject } from '@vuelidate/core';
import { type Ref } from 'vue';

const hasLeadingZero = /^0\d.*$/;

export const maxLength = (max: number) => {
  const validator = helpers.withParams({ type: `maxLength${max}` }, (value) => {
    if (typeof value === 'string' || Array.isArray(value)) {
      return value.length <= max;
    }
    if (typeof value?.toString === 'function') {
      const stringifiedValue = value.toString();
      return typeof stringifiedValue === 'string' ? stringifiedValue.length <= max : true;
    }
    return true;
  });
  validator.$message = () => `Lengte mag maximaal ${max} zijn.`;
  return validator;
};

export const required = helpers.withParams({ type: 'required' }, (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' || Array.isArray(value)) return value.length > 0;
  return true;
});
required.$message = () => 'Dit veld is verplicht.';

export const numeric = helpers.withParams(
  { type: 'numeric' },
  (value) => !Number.isNaN(Number(value)),
);
numeric.$message = () => 'Dit veld moet numeriek zijn.';

export const noLeadingZero = helpers.withParams(
  {
    type: 'noLeadingZero',
  },
  (value) => Number(value) !== 0 && !hasLeadingZero.test(<string>value),
);
noLeadingZero.$message = () => 'Dit veld mag niet met een 0 beginnen.';

// wrap each validator.
export const { email } = validators; // <ValidationRuleWithParams>withI18nMessage(validators.required);
email.$message = 'Dit veld moet een geldig email adres bevatten.';

export function mapErrors(
  errors: { $errors: ErrorObject[] } | { $errors: ErrorObject[] }[],
): Array<string | Ref<string>> {
  let messages: string[];
  if (Array.isArray(errors)) {
    messages = errors.flatMap((err) => err.$errors.map((e) => e.$message)) as string[];
  } else {
    messages = errors.$errors.map((e) => e.$message) as string[];
  }
  return messages;
}

export function getElementError(type: any, index: number, property: string) {
  return type.$each.$response.$data[index - 1][property].$error;
}

export function getElementMessage(type: any, index: number, property: string) {
  return type.$each.$response.$errors[index - 1][property][0]?.$message;
}

export function allVariablesInStringExist(string: string, variables: string[]) {
  const variableDetectionRegex = /\[(.*?)]/g;
  const matchedVariables = string.match(variableDetectionRegex);

  if (!matchedVariables || matchedVariables.length === 0) return true;
  return matchedVariables.every((variable) => variables.includes(variable));
}
